import { Link } from 'react-router-dom'
import '../styles/thank-you.css'

export function ThankYou() {
  return (
    <main className="thankyou-container">
      <div className="thankyou-card">
        <div className="thankyou-icon" aria-hidden="true">✓</div>
        <h1 className="thankyou-title">Thank You!</h1>
        <p className="thankyou-message">
          Your responses have been submitted successfully. We appreciate your time.
        </p>
        <Link to="/" className="thankyou-link">
          ← Back to surveys
        </Link>
      </div>
    </main>
  )
}
